import useWidgetContext from './useWidgetContext';
import { useMemo } from 'react';
import locale from '../service/locale';
import usePlatformConfig from './usePlatformConfig';
import priceFormatterFactory from '../../../../common/service/priceFormatterFactory';

export default function usePriceFormatter({
  currency,
  decimals = 2,
  useCurrencySign = true,
}: {
  currency?: string;
  decimals?: number;
  useCurrencySign?: boolean;
}): Intl.NumberFormat | { format: (price: number) => string } {
  const {
    configuration: {
      dimensions: { language, country },
    },
  } = useWidgetContext();
  const { platformConfig } = usePlatformConfig();

  return useMemo(() => {
    const currencyLocale: string = locale.getCurrencyLocaleCode(language, country, currency);
    const currencyArgs = useCurrencySign
      ? {
          currency: currency || platformConfig.priceDisplay.primary.currency,
          style: 'currency',
          currencyDisplay: 'symbol',
        }
      : {};
    const priceArgs = {
      ...currencyArgs,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    };

    return priceFormatterFactory.create(priceArgs, currencyLocale);
  }, [currency, decimals]);
}
